import { createBrowserRouter } from 'react-router-dom';
import { RequireAgent } from '@/auth/RequireAgent';
import { SignInPage } from '@/auth/SignInPage';
import { AppLayout } from './AppLayout';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { TournamentPage } from '@/features/tournament/TournamentPage';
import { LinkBuilderPage } from '@/features/links/LinkBuilderPage';
import { WheelSpinsPage } from '@/features/wheel/WheelSpinsPage';
import { WhalesPage } from '@/features/whales/WhalesPage';
import { TrafficQualityPage } from '@/features/traffic-quality/TrafficQualityPage';
import type { ConsoleReportId } from '@/api/types';

async function reportRoute(report: ConsoleReportId) {
  const { ReportPage } = await import('@/features/reports/ReportPage');
  return { element: <ReportPage report={report} /> };
}

export const router = createBrowserRouter([
  { path: '/sign-in', element: <SignInPage /> },
  {
    element: <RequireAgent />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'tournaments/:tournamentId', element: <TournamentPage /> },
          { path: 'links', element: <LinkBuilderPage /> },
          { path: 'wheel', element: <WheelSpinsPage /> },
          { path: 'whales', element: <WhalesPage /> },
          { path: 'traffic-quality', element: <TrafficQualityPage /> },
          // The analysts' reports carry their whole HTML; loaded on first visit, not with the app.
          { path: 'ar-traffic', lazy: () => reportRoute('ar-traffic') },
          { path: 'deposit-timing', lazy: () => reportRoute('deposit-timing') },
          { path: 'aff-trend', lazy: () => reportRoute('aff-trend') },
          { path: 'aff-comparison', lazy: () => reportRoute('aff-comparison') },
        ],
      },
    ],
  },
]);
